export default __webpack_public_path__ + "static/media/Profile.01bd0f98.svg";